import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { LegacyButton } from '@/components/LegacyButton';

export const EndImageContainer = styled(Box)<{
  $hasUrl?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.secondaryLightGrey};
  width: 18.33%;
  min-width: 18.33%;

  ${({ $hasUrl }) =>
    $hasUrl &&
    css`
      cursor: pointer;
    `}

  ${({ theme }) => theme.media.md.down} {
    width: 152px;
    min-width: 152px;
  }

  ${({ theme }) => theme.media.md.up} {
    &&& {
      align-self: stretch;
      height: auto;
    }

    .aspect-ratio-image.end-image {
      aspect-ratio: unset;
      height: 100%;
    }

    img.end-image {
      width: 100%;
      object-fit: cover;
    }
  }
`;

export const EndImageButton = styled(LegacyButton)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  opacity: 0.8;

  ${({ theme }) => css`
    padding: 1.2rem 2rem;
    white-space: wrap;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 16px);

    ${theme.media.sm.up} {
      bottom: 24px;
      width: calc(100% - 48px);
    }
  `}

  :hover {
    opacity: 1;
  }
`;
